import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  toastSuccessMessage,
  InputControl,
  InputValidationConstants,
  Loading,
  LogotypeBelkaPoziom,
  RegularExpressionConstants,
} from "wup-module1-base";
import { Form, Row, Col, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { AuthService } from "../../Services";
import "./Login.css";
import { toast } from "react-toastify";

function ForgotPassword() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const {
        register,
        handleSubmit,
        reset,
        setError,
        formState: { errors, isSubmitted },
    } = useForm({
        mode: "onSubmit",
    });

    useEffect(() => {
        console.log(errors);
      }, [errors]);


    const sendEmail = (data) => {
        setIsSubmitting(true);
        AuthService.sendForgotPasswordEmail(data)
            .then((response) => {
                toastSuccessMessage("Wysłaliśmy na Twój adres e-mail link do resetu hasła!");
                reset({ 'e-mail': '' });
            })
            .catch((error) => {
                if (error.response.status == 422) {
                    console.log("tutaj")
                    setError("e-mail", {
                        type: "manual",
                        message: error.response.data.error,
                    });
                } else {
                    toast.error("Wystąpił nieznany błąd.");
                }
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

  return (
    <Form onSubmit={handleSubmit(sendEmail)}>
      <Row className="row-header-logo">
      <Col md={12} className="login-image-col">
          <img
            className="d-inline-block image-fluid login-image"
            src={LogotypeBelkaPoziom}
            alt="Logo MAŁOPOLSKA"
          />
        </Col>
        <Col md={12} className="login-header-col">
          <div className="login-header-text">
            <h1 className="login-header d-inline-block align-self-end mb-1">
                Ponowne ustawienie hasła
            </h1>
          </div>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md={6}>
          <InputControl
            id="e-mail"
            label="E-mail"
            refs={{
              ...register("e-mail", {
                required: InputValidationConstants.required,
                pattern: {
                    value: RegularExpressionConstants.email,
                    message: InputValidationConstants.email,
                  },
              }),
            }}
            errors={isSubmitted ? errors : {}}
          />
        </Col>
      </Row>
      <Row className="my-0">
        <Col className="text-right">
            <Button className="simple-btn" onClick={() => navigate("/login")}>
              <a
                className="mr-3 text-dark text-underline cursor-pointer"
              >
                Powrót
              </a>
            </Button>
          <Button
            type="submit"
            variant="login-submit"
            disabled={isSubmitting}
            className="px-5"
          >
            {isSubmitting ? (
              <Loading size="sm" className="p-0" variant="light" />
            ) : (
              "Wyślij wiadomość"
            )}
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default ForgotPassword;
